import script from "./sf-drawer-toggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-drawer-toggle.vue?vue&type=script&lang=ts&setup=true"

import "./sf-drawer-toggle.vue?vue&type=style&index=0&id=5b39eb3a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b39eb3a"]])

export default __exports__